import { styled } from '@mui/system'
import { ARTICLE_CARD_SIZE, BORDER_RADIUSES, colors, fontSizes } from '../consts'

type stylesProps = {
  uiTheme?: 'light' | 'dark'
  size?: 'normal' | 'small' | 'featured'
  backgroundImg?: string
}

export const WrappedFeedCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '100%',
  '& .feedCard': {
    height: 340,
    [theme.breakpoints.between('md', 'lg')]: {
      height: 300,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: 280,
    },
    [theme.breakpoints.down('sm')]: {
      height: 260,
    },
  },
}))

export const ArticleCon = styled('div')<stylesProps>(({ size, uiTheme, theme }) => ({
  width: size ? ARTICLE_CARD_SIZE[size].desktop : 420,
  position: 'relative',
  [theme.breakpoints.between('md', 'lg')]: {
    width: size ? ARTICLE_CARD_SIZE[size].tablet : 350,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: size ? ARTICLE_CARD_SIZE[size].mobile : 300,
  },
  [theme.breakpoints.down('sm')]: {
    width: size ? ARTICLE_CARD_SIZE[size].smMobile : 280,
  },
  '& a': {
    color: uiTheme === 'dark' ? colors.white : colors.text,
    textDecoration: 'none',
    cursor: 'pointer',
    '& .cover': {
      borderRadius: theme.spacing(1),
      width: '100%',
    },
    '& .placeholder': {
      borderRadius: theme.spacing(1),
      objectFit: 'cover',
    },
  },
}))

export const ArticleTitle = styled('h2')<stylesProps>(({ uiTheme, theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.medium,
  color: uiTheme === 'dark' ? colors.white : colors.text,
  lineHeight: '120%',
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const ArticleAuthor = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: fontSizes.small,
  color: uiTheme === 'dark' ? colors.white : colors.text,
}))

export const HeadlineList = styled('ul')<stylesProps>(({ theme }) => ({
  fontSize: fontSizes.small,
  margin: 0,
  padding: 0,
  '& li': {
    listStyle: 'none',
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'baseline',
    '& svg': {
      marginRight: theme.spacing(1),
      width: theme.spacing(1),
      height: theme.spacing(1),
      fill: colors.yellow,
    },
    '& a': {
      textDecoration: 'none',
      color: colors.text,
    },
  },
}))

export const FeedRow = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: theme.spacing(2, 1),
  cursor: 'pointer',
  '& a': {
    color: uiTheme === 'dark' ? colors.white : colors.text,
    textDecoration: 'none',
    width: '100%',
  },
  '& .vidCon': {
    width: '100%',
  },
}))

export const FeedRowInner = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  display: 'flex',
  width: '100%',
  '& .leftColumn': {
    marginTop: theme.spacing(2),
    flexShrink: 0,
    width: 150,
    height: (150 * 9) / 16,
    [theme.breakpoints.down('md')]: {
      width: 125,
      height: (125 * 9) / 16,
    },
  },
  '& .detailsCon': {
    margin: theme.spacing(0, 2),
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0, 1),
    },
  },
}))

export const FeedThumb = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  borderRadius: BORDER_RADIUSES.medium,
  overflow: 'hidden',
  cursor: 'pointer',
  zIndex: 1,
  '& .imgCon': {
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    '& img': {
      maxHeight: '100%',
      maxWidth: '100%',
      objectFit: 'contain',
      zIndex: 2,
    },
  },
  '& .playBtn': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
  },
  '& .durationCon': {
    position: 'absolute',
    left: 5,
    bottom: 8,
    borderRadius: 12,
    background: `${colors.offWhite}98`,
    padding: theme.spacing(0.5, 1.5),
    zIndex: 2,
    [theme.breakpoints.between('md', 'lg')]: {
      bottom: 6,
    },
    [theme.breakpoints.down('md')]: {
      bottom: 5,
      padding: theme.spacing(0.25, 1),
    },
    '& .durationText': {
      fontSize: fontSizes.small,
      color: colors.black,
      fontWeight: 'bold',
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
}))

export const FeedBlurredBackground = styled('div')<{ backgroundImg: string }>(
  ({ backgroundImg, theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'blur(5px)',
  })
)

export const HeadlinesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))
export const HeadlineItem = styled('div')(({ theme }) => (  {
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}))

export const IconContainer = styled('div')(({ theme }) => ({
  marginTop: 2,
  width: 15,
  height: 20,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    marginTop: 0,
  },
}))

export const HeadlineText = styled('span')(({ theme }) => ({
  color: colors.text,
  fontSize: fontSizes.medium,
  lineHeight: 1.3,
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))
